/**
 * Header tools.
 */
function header_tools() {
    /**
     * Sets the stored height of the header to the specified value.
     *
     * @param {*} headerHeight A new height for the header
     */
    function setHeaderHeight(headerHeight) {
        // console.log(`Header height: ${headerHeight}`);
        document.documentElement.style.setProperty(
            '--header-height',
            `${headerHeight}px`
        );
        window.header_tools.currentHeaderHeight = headerHeight;
    }

    // Return an object to expose inner functions
    return {
        currentHeaderHeight: 0,
        setHeaderHeight: setHeaderHeight,
    };
}

// Store tools in window
window.header_tools = header_tools();
